/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  IconButton,
  Button,
  Breadcrumbs,
} from "@mui/material";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import FolderCopyIcon from "@mui/icons-material/FolderCopy";
import AddIcon from "@mui/icons-material/Add";
import { useLocation } from "react-router-dom";
import useAxiosPrivate from "contexts/interceptors/axios";
import AddSubdirectoryModal from "../../../../../modals/i-abide/AddSubdirectoryModal";

export default function Subdirectories() {
  const axiosPrivate = useAxiosPrivate();
  const location = useLocation();
  const { subdirectoryName, parentDirectoryId } = location.state || {};
  const [modalOpen, setModalOpen] = useState(false);
  const [subdirectories, setSubdirectories] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchSubdirectories = async () => {
    if (parentDirectoryId) {
      await axiosPrivate
        .get(`/I-Abide/getSubdirectories/${parentDirectoryId}`)
        .then((res) => {
          setSubdirectories(res.data || []);
        })
        .catch((err) => {
          console.error("Error fetching subdirectories:", err);
          setError("Failed to fetch subdirectories."); // Handle error case
        });
    }
  };

  // Fetch subdirectories by parent ID when component mounts
  useEffect(() => {
    fetchSubdirectories();
  }, [parentDirectoryId]);

  // Handle adding a new subdirectory
  const handleAddSubdirectory = (subdirectoryData) => {
    setLoading(true);

    axiosPrivate
      .post(`/I-Abide/create-subdirectory`, subdirectoryData)
      .then((response) => {
        fetchSubdirectories();
        setModalOpen(false);
      })
      .catch((error) => {
        console.error("Error creating subdirectory:", error);
        setError("Failed to create subdirectory."); // Handle error case
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Box p={1}>
      <Box sx={{ p: 2, background: "black" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            textAlign: "center",
            gap: 2,
          }}
        >
          <FolderCopyIcon style={{ fontSize: 50, color: "#ecfc08" }} />
          <Typography
            variant="h5"
            sx={{ fontFamily: "Poppins", fontWeight: "bold", color: "white" }}
          >
            SUBDIRECTORIES
          </Typography>
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" sx={{ p: 3, mt: 2 }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Typography color="text.primary">Directories</Typography>
          <Typography color="text.secondary">{subdirectoryName}</Typography>
        </Breadcrumbs>

        <Button
          variant="outlined"
          color="primary"
          endIcon={<AddIcon />}
          onClick={() => setModalOpen(true)}
          sx={{
            fontSize: "1.2rem",
            padding: "12px 24px",
            minWidth: "180px",
            "&:hover": {
              backgroundColor: "#007BFF",
              borderColor: "#0056b3",
              color: "#fff",
            },
          }}
        >
          ADD SUBDIRECTORY
        </Button>
      </Box>
      <AddSubdirectoryModal
        loading={loading}
        open={modalOpen} // Control modal visibility
        handleClose={() => setModalOpen(false)} // Close modal function
        parentDirectoryId={parentDirectoryId} // Pass parent ID to modal
        handleAddSubdirectory={handleAddSubdirectory} // Pass the function to handle adding subdirectory
      />
      {subdirectories.length > 0 ? (
        <Box mt={2}>
          <Grid container spacing={2}>
            {subdirectories.map((subdir) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={subdir.id}>
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  textAlign="center"
                >
                  <IconButton color="primary">
                    <FolderSharedIcon style={{ fontSize: 100 }} />
                  </IconButton>
                  <Typography variant="subtitle1">
                    {subdir.subdirectoryName}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      ) : (
        <Typography>No subdirectory available.</Typography>
      )}
      {error && <Typography color="error">{error}</Typography>}{" "}
      {/* Display error message if any */}
    </Box>
  );
}
